module.exports = __webpack_public_path__ + "static/img/bg.dec486a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/team/bg.jpg
// module id = 8A4Y
// module chunks = 7